import React, { useState, useEffect } from 'react';
import { Drawer, Button, Select, Radio, Input, Divider, Row, Col, Form, Space, message, Checkbox, Typography } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import FiltersDynamic from '../Components/FiltersDynamicComponent';
import { BASE_URL, helpTextFormula } from '../Components/Constant';
import ApiService from '../Components/apiService';

const { Option } = Select;
const { Title, Text } = Typography;

const StartNodeDrawer = ({ nodeData, openDrawer, onClose, onSave,startData }) => {
  const [form] = Form.useForm();
  const [objectList, setObjectList] = useState([]);
  const [fieldsData, setFieldsData] = useState([]);
  const [logicForROllUpFilters, setLogicForRollUpFilters] = useState('');
  const [rollUpFilters, setRollUpFilters] = useState([]);
  const [valueOperatorForRollUpFilters, setValueOperatorForRollUpFilters] = useState('');
  const [lookupOptionsForRollUpFilters, setLookupOptionsForRollUpFilters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedObject, setSelectedObject] = useState(false);
  const [rollUpFiltersFields, setRollUpFiltersFields] = useState([]);
  const [runAsync, setRunAsync] = useState(false); // State for checkbox
  const [fastAction,setFastAction] = useState("");

  useEffect(() => {
    if (nodeData && openDrawer && startData) {
      console.log('start data:',startData);
      form.setFieldsValue({
        object: startData?.object,
        trigger: startData?.trigger,
        optimization: startData?.optimization || 'before_create',  // optional fallback
      });
  
      if (nodeData.object) {
        setSelectedObject(nodeData?.object);
        fetchfields(nodeData?.object);  // fetch fields
      }
  
      setRollUpFilters(nodeData?.conditions || []);
      setLogicForRollUpFilters(nodeData?.logic || '');
      setRunAsync(nodeData?.runAsync || false);
    }
  }, [nodeData, openDrawer]);
  

  
  useEffect(() => {
    const fetchObjects = async () => {
      try {
        const apiService = new ApiService(
          `${BASE_URL}/mt_objects`,
          { 'Content-Type': 'application/json' },
          'GET'
        );
        const response = await apiService.makeCall();
        if (Array.isArray(response)) {
          setObjectList(response.map(obj => obj.name));
        } else {
          setObjectList([]);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchObjects();
  }, []);

  const fetchfields = async (objName) => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_fields/object/${objName}`, {
        "Content-Type": "application/json",
      });
      const res = await apiService.makeCall();
      setFieldsData(res);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleObjectChange = (value) => {
    setSelectedObject(value);
    fetchfields(value);
  };

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      // Prepare the data you want to send to the parent
      const dataToSend = {
        ...values,
        conditions: rollUpFilters,
        runAsync: runAsync,
        fastAction: fastAction
      };
  
      console.log('Sending data to parent:', dataToSend);
      
      // Call the parent's onSave with data
      if (onSave) {
        onSave(dataToSend);
      }
  
      message.success('Start Node Data Saved Successfully');
      
      // Close the drawer
      onClose();
    }).catch(err => {
      console.log('Validation Failed:', err);
    });
  };
  

  const fetchLookupRecordsForExistingFilters = (existingFilters) => {
    existingFilters?.forEach(filter => {
      const selectedField = rollUpFiltersFields?.find(field => field.name === filter.field.replace('_id', ''));
      if (selectedField && selectedField.type === 'lookup') {
        fetchLookupRecords(selectedField.parent_object_name);
      }
    });
  };

  const fetchLookupRecords = async (objectName) => {
    try {
      const apiServiceForRecords = new ApiService(
        `${BASE_URL}/fetch_records/${objectName}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiServiceForRecords.makeCall();
      const records = response.map(record => ({
        value: record._id,
        label: record.Name,
        displayValue: record.Name
      }));
      setLookupOptionsForRollUpFilters(records);
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save field due to an unknown error';
      message.error(errorMessage);
    }
  };

  return (
    <Drawer
      title="Configure Start Node"
      width={600}
      mask={false}
      zIndex={1002}   // higher than sidebar
      onClose={onClose}
      visible={openDrawer}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} type="primary">
            Save
          </Button>
        </div>
      }
    >
      <Form layout="vertical" form={form}>
        <div style={{ marginBottom: 30 ,marginTop: 30}}>
        <div style={{ marginBottom: 8 }}>
          <Text strong>Select Object</Text>
          </div>
          <Form.Item
            name="object"
            rules={[{ required: true, message: 'Please select an object' }]}
          >
            <Select placeholder="Select object" onChange={handleObjectChange}>
              {objectList.map(obj => (
                <Option key={obj} value={obj}>{obj}</Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <Divider style={{borderBlockStart: '2px solid #d9d9d9'}}orientation="left"></Divider>

        <div style={{ marginBottom: 30 ,marginTop: 30}}>
        <div style={{ marginBottom: 8 }}>
          <Text strong>Trigger the Flow When</Text>
          </div>
          <Form.Item name="trigger" initialValue="create">
            <Radio.Group onChange={(e) => console.log('Trigger type:', e.target.value)}>
              <Space direction="vertical">
                <Radio value="create">A record is created</Radio>
                <Radio value="update">A record is updated</Radio>
                <Radio value="create_update">A record is created or updated</Radio>
                <Radio value="delete">A record is deleted</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </div>

        <Divider style={{borderBlockStart: '2px solid #d9d9d9'}}orientation="left"></Divider>
        <Text strong>Entry Conditions</Text>
        <div style={{ marginBottom: 30, marginTop: 30 }}>
          <FiltersDynamic
            fields={fieldsData}
            logic={logicForROllUpFilters}
            setLogic={setLogicForRollUpFilters}
            filters={rollUpFilters}
            setFilters={setRollUpFilters}
            setValueOperator={setValueOperatorForRollUpFilters}
            valueOperator={valueOperatorForRollUpFilters}
            fetchLookupRecordsForExistingFilters={fetchLookupRecordsForExistingFilters}
            fetchLookupRecords={fetchLookupRecords}
            lookupOptions={lookupOptionsForRollUpFilters}
          />
        </div>

        <Divider 
        style={{
        // width: '80%',
        borderBlockStart: '2px solid #d9d9d9' // increases thickness
        }}
        orientation="left"
        >

        </Divider>

        <div style={{ marginBottom: 30 ,marginTop: 30 }}>
        <div style={{ marginBottom: 8 }}>
          {/* <Text strong>Optimize the Flow for</Text> */}
          <Text strong>Select the event below</Text>
          </div>
          <Form.Item name="optimization">
            <Select defaultValue="before_create" onChange={(val) => setFastAction(val)}>
              {/* <Option value="fast">Fast Field Updates</Option>
              <Option value="actions">Actions and Related Records</Option> */}
              <Option value="before_create">Before Create</Option>
              <Option value="after_create">After Create</Option>
            </Select>
          </Form.Item>
        </div>

        <Divider style={{borderBlockStart: '2px solid #d9d9d9'}}orientation="left"></Divider>

        <div style={{ marginBottom: 30 ,marginTop: 30 }}>
          <Checkbox checked={runAsync} onChange={(e) => setRunAsync(e.target.checked)}>
            Include a <Text strong>Run Asynchronously</Text> path to access an external system after the original transaction for the triggering record is successfully committed
          </Checkbox>
        </div>
      </Form>
    </Drawer>
  );
};

export default StartNodeDrawer;
